<template>
  <div class="store-rebind-log">
    <app-query-bar
      :queryConfig="queryConfig"
      v-model="queryData"
      @onSearch="fetchLogs" />
    <app-data-table
      :columns="LOG_COLUMNS"
      :data="logs"
      v-model="queryData"
      @onPageConfigChange="fetchLogs" />
  </div>
</template>

<script>
import { LOG_COLUMNS } from './constants';
import StoreRebindLogApi from './store-rebind-log.api';
// import DataTransferUtil from '@/utils/data-transfer.util';

export default {
  name: 'store-rebind-log',
  data() {
    return {
      LOG_COLUMNS,
      queryConfig: [
        {
          fieldName: 'storeName',
          name: '门店名称',
        },
        {
          fieldName: 'optNickName',
          name: '操作人',
        },
      ],
      queryData: {
        page: 1,
        limit: 10,
        count: 0,
        store_name: '',
        opt_nick_name: '',
      },
      logs: [],
    };
  },
  created() {
    this.fetchLogs();
  },
  methods: {
    async fetchLogs() {
      const {
        page,
        limit,
        storeName,
        optNickName,
      } = this.queryData;
      const {
        count = 0,
        results = [],
      } = await StoreRebindLogApi.getLogs(
        page,
        limit,
        storeName,
        optNickName,
      );
      this.logs = results;
      this.$set(this.queryData, 'count', count);
    },
  },
};
</script>

<style scoped>

</style>
